import React from 'react';
import PropTypes from 'prop-types';
import MessageCard from '~/components/MessageCard';
import {SAVE_CTA} from '~/constants/ResponsiveImageConstants';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const SaveCTA = props => {
  const getText = () => {
    return (
      <div>
        <p>Once you save, you can view your design</p>
        <p>on any device. We’ll hold onto it until you’re</p>
        <p>ready to make awesome happen!</p>
      </div>
    );
  };

  const ctaProps = {
    bodyText: getText(),
    calloutText: 'Save Your Creation',
    imageName: SAVE_CTA,
    floatingLinkText: 'Save Your Design',
    onFloatingLinkClick: props.onFloatingLinkClick
  };

  return <MessageCard {...ctaProps} />;
};

SaveCTA.displayName = 'SaveCTA';

const propTypes = {
  onFloatingLinkClick: PropTypes.func
};

SaveCTA.propTypes = propTypes;

export default SaveCTA;
